"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  if (process.env.GATSBY_ACTIVE_ENV === "production" && window.pintrk) {
    pintrk('page');
  }
};